import { forwardRef, Fragment } from "react";
import Box from "@mui/material/Box";
import classes from "./PrintContent.module.css";
import Typography from "@mui/material/Typography";
import {
  DateField,
  NumberField,
  RecordContextProvider,
  // usePermissions,
} from "react-admin";
import splitArrayToChunks from "../../../utils/splitArrayToChunks";
import useTaxPostingMode from "../../../hooks/useTaxPostingMode";

const PrintContent = forwardRef((props, ref) => {
  // eslint-disable-line max-len
  // const { permissions, isLoading } = usePermissions();
  const { isManualTaxPosting } = useTaxPostingMode();

  const parsedTaxRate = Number(props?.record?.tax_rate);
  const effectiveTaxRate = Number.isFinite(parsedTaxRate) && parsedTaxRate >= 0 ? parsedTaxRate : 0.11;
  const dppDenominator = 1 + effectiveTaxRate;

  let totalReceived = 0;
  return (
    <Box
      component="div"
      sx={{
        display: "none",
      }}
    >
      <Box ref={ref}>
        <style type="text/css" media="print">
          {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
              break-after: page;
              height: 0;
            }
            .page-break:last-child {
              page-break-after: auto;
              break-after: auto;
            }
            .big-back::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-image: url('/atena-tiles.png');
              background-repeat: no-repeat;
              background-position: 50% 28%;
              background-size: 20% auto;
              opacity: 0.2;
              z-index: -1;
            }
          `}
        </style>
        {splitArrayToChunks(props.record.purchase_return_items, 5).map(
          (arr, i, ori) => {
            return (
              <Fragment key={i}>
                <Box
                  className="big-back"
                  sx={
                    i > 0
                      ? {
                          position: "relative",
                          overflow: "hidden",
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                      : {
                          position: "relative",
                          overflow: "hidden",
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                  }
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "uppercase",
                        fontFamily: "inherit",
                      }}
                    >
                      {props.record.company.name}
                    </Typography>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        component="span"
                        sx={{
                          pr: 1,
                          fontFamily: "inherit",
                        }}
                      >
                        Print date:
                      </Typography>
                      <RecordContextProvider value={props.record}>
                        <DateField
                          source="print_date"
                          sx={{
                            fontWeight: "inherit",
                            fontSize: "12px",
                            fontFamily: "inherit",
                          }}
                          options={{
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                          }}
                        ></DateField>
                      </RecordContextProvider>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      textTransform: "uppercase",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                      fontFamily: "inherit",
                    }}
                  >
                    Retur pembelian
                  </Typography>
                  <table className={classes.headerSj}>
                    <thead>
                      <tr>
                        <th>No. Voucher</th>
                        <th>:</th>
                        <th>{props.record.code}</th>
                        <th style={{ width: "50%" }}></th>
                        <th>No. Order</th>
                        <th>:</th>
                        <th>
                          {
                            props.record.purchase_return_items[0].purchase_item
                              .purchase_order_item.purchase_order.code
                          }
                        </th>
                      </tr>
                      <tr>
                        <th>Tgl. Bukti</th>
                        <th>:</th>
                        <th>
                          <RecordContextProvider value={props.record}>
                            <DateField
                              source="date"
                              sx={{
                                fontWeight: "inherit",
                                fontSize: "12px",
                                fontFamily: "inherit",
                              }}
                              options={{
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                              }}
                            ></DateField>
                          </RecordContextProvider>
                        </th>

                        <th style={{ width: "50%" }}></th>
                        <th>No. Penerimaan</th>
                        <th>:</th>
                        <th>
                          {
                            props.record.purchase_return_items[0].purchase_item
                              .purchase.code
                          }
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 1.5,
                      mb: 1,
                      fontFamily: "inherit",
                    }}
                  >
                    Keterangan: {props.record.note}
                  </Typography>
                  <table className={`${classes.tableSj} ${classes.purchaseReturnItems}`}>
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Kode Barang</th>
                        <th>Nama</th>
                        <th>KW</th>
                        <th style={{ textAlign: "right" }}>Kuantitas</th>
                        <th style={{ textAlign: "right" }}>Harga</th>
                        {!isManualTaxPosting ? (
                          <th style={{ textAlign: "right" }}>DPP</th>
                        ) : null}
                        {!isManualTaxPosting ? (
                          <th style={{ textAlign: "right" }}>PPN</th>
                        ) : null}
                        <th style={{ textAlign: "right" }}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arr.map((obj, idx) => {
                        totalReceived += obj.return_quantity;
                        const nettPrice =
                          obj.purchase_item.purchase_order_item.price -
                          obj.purchase_item.purchase_order_item.disc;
                        const dppUnit = isManualTaxPosting
                          ? 0
                          : dppDenominator > 0
                          ? Math.round(nettPrice / dppDenominator)
                          : Math.round(nettPrice);
                        const ppnUnit = isManualTaxPosting ? 0 : nettPrice - dppUnit;
                        const dppTotal = dppUnit * obj.return_quantity;
                        const ppnTotal = ppnUnit * obj.return_quantity;
                        return (
                          <tr
                            key={
                              obj.purchase_item.purchase_order_item.product.id
                            }
                          >
                            <td style={{ textAlign: "center" }}>{idx + 1}</td>
                            <td>
                              {
                                obj.purchase_item.purchase_order_item.product
                                  .code
                              }
                            </td>
                            <td>
                              {
                                obj.purchase_item.purchase_order_item.product
                                  .name
                              }
                            </td>
                            <td>
                              {
                                obj.purchase_item.purchase_order_item.product
                                  .quality_name
                              }
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {obj.return_quantity}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <RecordContextProvider
                                value={obj.purchase_item.purchase_order_item}
                              >
                                <NumberField
                                  source="price"
                                  sx={{
                                    fontWeight: "inherit",
                                    fontSize: "11px",
                                    fontFamily: "inherit",
                                  }}
                                ></NumberField>
                              </RecordContextProvider>
                            </td>
                            {!isManualTaxPosting ? (
                              <td style={{ textAlign: "right" }}>
                                <RecordContextProvider value={{ dpp: dppTotal }}>
                                  <NumberField
                                    source="dpp"
                                    sx={{
                                      fontWeight: "inherit",
                                      fontSize: "11px",
                                      fontFamily: "inherit",
                                    }}
                                  ></NumberField>
                                </RecordContextProvider>
                              </td>
                            ) : null}
                            {!isManualTaxPosting ? (
                              <td style={{ textAlign: "right" }}>
                                <RecordContextProvider value={{ ppn: ppnTotal }}>
                                  <NumberField
                                    source="ppn"
                                    sx={{
                                      fontWeight: "inherit",
                                      fontSize: "11px",
                                      fontFamily: "inherit",
                                    }}
                                  ></NumberField>
                                </RecordContextProvider>
                              </td>
                            ) : null}
                            <td style={{ textAlign: "right" }}>
                              <RecordContextProvider value={obj}>
                                <NumberField
                                  source="subtotal"
                                  sx={{
                                    fontWeight: "inherit",
                                    fontSize: "11px",
                                    fontFamily: "inherit",
                                  }}
                                ></NumberField>
                              </RecordContextProvider>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          colSpan={3}
                          style={{
                            textAlign: "right",
                            verticalAlign: "baseline",
                            fontWeight: "bold",
                            borderRight: "none",
                          }}
                        >
                          Total:
                        </td>
                        <td
                          style={{
                            textAlign: "right",
                            verticalAlign: "baseline",
                            fontWeight: "bold",
                            borderLeft: "none",
                          }}
                        ></td>
                        <td style={{ textAlign: "right" }}>{totalReceived}</td>
                        <td colSpan={isManualTaxPosting ? 1 : 3}></td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={props.record}>
                            <NumberField
                              source="total"
                              sx={{
                                fontWeight: "inherit",
                                fontSize: "11px",
                                fontFamily: "inherit",
                              }}
                            ></NumberField>
                          </RecordContextProvider>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <Typography
                    variant="caption"
                    sx={{
                      mt: "auto",
                      textTransform: "capitalize",
                      fontFamily: "inherit",
                    }}
                  >
                    {"Terbilang: # " +
                      props.record.total_in_words +
                      " Rupiah #"}
                  </Typography>
                  <div className={classes.signatureBox}>
                    <table className={classes.tableACC}>
                    <thead>
                      <tr>
                        <th colSpan={2} style={{ borderBottom: "1px solid #000" }}>
                          Mengetahui
                        </th>
                        <th colSpan={2} style={{ borderBottom: "1px solid #000" }}>
                          Pemeriksa
                        </th>
                        <th style={{ borderBottom: "1px solid #000" }}>
                          Pelaksana
                        </th>
                      </tr>
                      <tr>
                        <th
                          style={{ textTransform: "uppercase", width: "20%" }}
                        >
                          Akunting JKT
                        </th>
                        <th
                          style={{ textTransform: "uppercase", width: "20%" }}
                        >
                          Kepala Depo
                        </th>
                        <th
                          style={{ textTransform: "uppercase", width: "20%" }}
                        >
                          Akunting
                        </th>
                        <th
                          style={{ textTransform: "uppercase", width: "20%" }}
                        >
                          Administrasi
                        </th>
                        <th
                          style={{ textTransform: "uppercase", width: "20%" }}
                        >
                          Kepala Gudang
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>(TATI K.)</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                    </table>
                  </div>
                </Box>
                <div className="page-break" />
              </Fragment>
            );
          }
        )}
      </Box>
    </Box>
  );
});
export default PrintContent;
